import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { $calendar } from '../../Calendar.store';
import Card from '../Card';
import { usePreparedCardData } from '../Card.hooks';
import styles from './TravelCard.module.scss';
const TravelCard = ({ date, data }) => {
    const { t } = useTranslation();
    const travel = $calendar.travels[data.id];
    const cardData = usePreparedCardData({
        date,
        data,
        itemBegin: travel.appointedStart,
        itemEnd: travel.appointedFinish,
    });
    return (_jsx(Card, Object.assign({ date: date, data: data, cardData: cardData, colors: !cardData.isPast && { bg: '#FEF3D7', title: '#967522' }, subTitle: t('label.travel'), className: classNames(styles.wrapper, cardData.isPast && styles.isPast) }, { children: _jsx(Icon, { type: 'carTravel', className: styles.icon }) })));
};
export default observer(TravelCard);
